<template>
  <div>
    <nav aria-label='breadcrumb'>
      <ol class='breadcrumb'>
        <li class='breadcrumb-item'>
          <a href='/archive-stock'>在庫管理</a>
        </li>
        <li class='breadcrumb-item active' aria-current='page'>委託在庫の戻り</li>
      </ol>
    </nav>
    <div class='container-fluid main-container'>
      <div class='d-flex flex-wrap'>
        <div class='left-container'>
          <div class='form-inline mb-3'>
            <div class='form-group'>
              <button :disabled="!currentInfo.client_id" class='btn btn btn-info ' data-toggle="modal" data-target="#SingleConsignmentStockReturnModal" >納品状態確認</button>
            </div>
          </div>
          <h5 class='mb-3'>Information</h5>
          <table class='table table-sm table-borderless table-information'>
            <tbody>
              <tr>
                <th>請求先</th>
                <td>
                  <button
                    ref='info04'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info04'
                    data-placement='right'
                  >{{ currentInfo.client ? currentInfo.client : '-----------' }}</button>
                  <div ref="popover-info04" id='popover-info04' class='popover popover-x popover-default popover-fit-content'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>請求先
                    </div>
                    <div class='popover-body popover-content'>
                      <v-select :options="clients" label="name" value="id" v-model="tempInfo.client"></v-select>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('client_id', tempInfo.client, 'info04')">更新</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>戻り先倉庫</th>
                <td>
                  <button
                    ref='info05'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info05'
                    data-placement='right'
                  >{{ currentInfo.warehouse ? currentInfo.warehouse : '----------'}}</button>
                  <div id='popover-info05' class='popover popover-x popover-default popover-fit-content'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>倉庫
                    </div>
                    <div class='popover-body popover-content'>
                      <v-select :options="warehouses" label="name" value="id" v-model="tempInfo.warehouse"></v-select>
                    </div>
                    <div class='popover-footer'>
                      <button
                        @click="updateField('warehouse_id',tempInfo.warehouse,'info05')"
                        type='submit'
                        class='btn btn-sm btn-primary'
                      >更新</button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <hr>
        </div>
      </div>
    </div>
    <SingleConsignmentStockReturnModal :client-id="currentInfo.client_id" :outsourcingStatus="outsourcingstatus"/>
    <vue-element-loading :active='isLoading' :is-full-screen='true'/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import SingleConsignmentStockReturnModal from '@/components/SingleConsignmentStockReturnModal'

export default {
  name: 'ConsignmentStockReturn',
  props: {},
  components: {
    VueElementLoading,
    SingleConsignmentStockReturnModal
  },

  data () {
    return {
      outsourcingstatus: 0,
      currentInfo: {
        client_id: null
      },
      tempInfo: {},
      isLoading: false
    }
  },

  computed: {
    clients () {
      return this.$store.getters['Master/getBillTo']
    },
    warehouses () {
      return this.$store.getters['Master/getMywarehouses']
    }
  },

  created () {
    this.$store.dispatch('Master/checkBillTo')
    this.$store.dispatch('Master/checkMywarehouses')
  },

  mounted () {
    this.popoverButtons()
  },

  methods: {
    popoverButtons () {
      window.$('button[data-toggle="popover-x"]').each(function () {
        let targetID = window.$(this).attr('data-target')
        window.$(this).popoverButton({
          target: targetID,
          trigger: 'click'
        })
      })
    },
    /**
     * @param field : orders information props
     * @param value : value
     * @param ref   : reference trigger
     */
    updateField (field, value, ref) {
      const $this = this
      let val = ''
      if (
        !value ||
        value === '-' ||
        value === '' ||
        typeof value === 'undefined'
      ) {
        this.$refs[ref].innerText = '-----------'
        val = ''
      } else if (field === 'client_id') {
        this.clients.forEach(function (v) {
          if (v.id === parseInt(value.id)) {
            $this.$refs[ref].innerText = v.name
            val = v.id
          }
        })
      } else if (field === 'warehouse_id') {
        this.warehouses.forEach(function (v) {
          if (v.id === parseInt(value.id)) {
            $this.$refs[ref].innerText = v.name
            val = v.id
          }
        })
      }
      this.currentInfo[field] = val
      window.$('#popover-' + ref).popoverX('hide')
      console.log(this.currentInfo)
    }
  }
}
</script>
